import { render, staticRenderFns } from "./board-column-tasks.vue?vue&type=template&id=8f1e8794&"
import script from "./board-column-tasks.vue?vue&type=script&lang=js&"
export * from "./board-column-tasks.vue?vue&type=script&lang=js&"
import style0 from "./board-column-tasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports